import { render, staticRenderFns } from "./VasionDropList.vue?vue&type=template&id=1de271a9&scoped=true"
import script from "./VasionDropList.vue?vue&type=script&lang=js"
export * from "./VasionDropList.vue?vue&type=script&lang=js"
import style0 from "./VasionDropList.vue?vue&type=style&index=0&id=1de271a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de271a9",
  null
  
)

export default component.exports